export default Object.freeze({
  videoCodec: {
    title: 'Video codec',
    message:
      'Select from the list of codecs that are compatible with the container of this output.',
  },
  resolution: {
    title: 'Resolution',
    message:
      'Width - define video resolution width, in pixels for this output. Height - define the video resolution height for this output. If no value is provided the encoder will use the input width and height.',
  },
  rateControlMode: {
    title: 'Rate control mode',
    message:
      'Use this setting to specify rate control mode for an output. Select either VBR - variable bitrate, or CBR - constant bitrate.',
  },
  qualityTuningLevel: {
    title: 'Quality tuning level',
    message:
      'Use Quality tuning level to choose how you want to trade off encoding speed for output video quality. The default behavior is faster, lower quality, single-pass encoding.',
  },
  fragmentationType: {
    title: 'Fragmentation Type',
    message:
      'Fragmentation is enabled by setting one of the options that define how to cut the file into fragments',
  },
  presetOption: {
    title: 'Preset Options',
    message:
      'This option itemizes a range of choices from veryfast (best speed) to veryslow (best quality).',
  },
  bitrate: {
    title: 'Bitrate',
    message:
      'Specify the average bitrate in bits per second. Required for VBR and CBR.',
  },
  framerate: {
    title: 'Framerate',
    message:
      'Provide the value as a decimal number for Framerate. For example, specify 23.976.',
  },
  aspectRatio: {
    title: 'Aspect ratio',
    message:
      'If you specify any value other than Follow source. PAR Numerator and Denominator: When you specify an output pixel aspect ratio (PAR) that is different from your input video PAR, provide your output PAR as a ratio. For example, for D1/DV NTSC widescreen, you would specify the ratio 40:33. In this example, the value for PAR Numerator is 40 and the PAR Denominator is 33.',
  },
  gopSize: {
    title: 'GOP size',
    message:
      'Specify the GOP length using a whole number of frames or a decimal value of seconds.',
  },
  gopUnit: {
    title: 'GOP unit',
    message: 'Specify how the transcoder determines GOP size for this output',
  },
  bFrames: {
    title: 'B frames between reference frames',
    message:
      'This setting to determines the number of B-frames that Encoder puts between reference frames in this output.',
  },
  codecProfile: {
    title: 'Codec Profile',
    message:
      'H.264 Profile. High 4:2:2 and 10-bit profiles are only available with the AVC-I License.',
  },
  colorMetadata: {
    title: 'Color metadata',
    message:
      "Choose Insert for this setting to include color metadata in this output. Choose Ignore to exclude color metadata from this output. If you don't specify a value, the service sets this to Insert by default.",
  },
  codecLevel: {
    title: 'Codec level',
    message:
      "Specify an H.264 level that is consistent with your output video settings. If you aren't sure what level to specify, choose Auto",
  },
  deinterlacer: {
    title: 'Deinterlacer',
    message:
      'Deinterlace algorithm - Only applies when you set Deinterlacer Mode to Deinterlace or Adaptive. Motion Adaptive interpolate produces sharper pictures, while Blend produces smoother motion.',
  },
  scale: {
    title: 'Scale',
    message:
    'If enabled, despite the original resolution the input will be scaled to the provided width x height properties.',
  },
})
